import React from "react";
import cycleImg from "../../images/robinet.png";
const PatrimoineSource = () => {
  return (
    <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
      <div className="flex items-center justify-center">
        <img src={cycleImg} alt="" className="w-full max-w-full" />
      </div>
    </div>
  );
};

export default PatrimoineSource;
